<template>
  <div class="comp">
    <div class="compContent">
      <div class="title">
        <div class="titleL">新增医疗服务</div>
        <div class="titleR">
          <el-button type="warning" plain size="small" @click="back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content">
        <div class="msg">
          <div class="msgItem" >
            <div class="label">套餐项目:</div>
            <div class="value">
              <el-button
                v-if="$public.isNull(curPackage.groupId)"
                @click="open_dialogAddShop"
                :disabled="$public.isNull(curPetInfo._id)"
                size="small"
                >添加医疗服务套餐</el-button
              >

              <div
                v-else
                @click="open_dialogAddShop"
                style="cursor: pointer; line-height: 32px"
              >
                {{ curPackage.title }}
              </div>
            </div>
          </div>
          <!-- couPackageList -->
          <div class="msgItem" v-if="couponList.length">
            <div class="label">优惠券:</div>
            <div class="value">
              <el-select
                v-model="couponId"
                filterable
                clearable
                placeholder="请选择"
                size="small"
                style="width: 210px"
                @change="changeCoupon"
              >
                <el-option
                  v-for="item in couponList"
                  :key="item._no"
                  :label="item.coupon_name+'('+item._no+')'"
                  :value="item._no"
                ></el-option>
              </el-select>
            </div>
          </div>
          <!-- 可用套餐 -->
          <div class="msgItem" v-if="couponList.length">
            <div class="label">优惠券可用套餐:</div>
            <div class="value">
              <el-select
              clearable
                v-model="couPackageId"
                filterable
                placeholder="请选择"
                size="small"
                style="width: 210px"
                @change="changeCouPackage"
              >
                <el-option
                  v-for="item in couPackageList"
                  :key="item.goods_id"
                  :label="item.goods_name"
                  :value="item.goods_id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="msgItem">
            <div class="label">销售人员:</div>
            <div class="value">
              <el-select
                v-model="saleManIdList"
                multiple
                filterable
                placeholder="请选择"
                size="small"
                style="width: 210px"
              >
                <el-option
                  v-for="item in staffList"
                  :key="item._id"
                  :label="item.basic_info.nick_name"
                  :value="item._id + ',' + item.basic_info.nick_name"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="msgItem">
            <div class="label">备注:</div>
            <div class="value">
              <el-input
                v-model="form.remark"
                size="small"
                style="width: 220px"
              ></el-input>
            </div>
          </div>
          <div class="msgItem" style="width: 15%">
            <div class="label">支付方式:</div>
            <div class="value">
              <span style="line-height: 32px">全额支付</span>
            </div>
          </div>
        </div>
        <div style="text-align: right; padding: 0 20px 20px 0">
          <el-button
            type="warning"
            size="small"
            @click="submit"
            style="width: 120px"
            >创建</el-button
          >
        </div>
        <div class="review">
          <el-table border :data="tableData" ref="table" height="100%">
            <el-table-column label="名称" prop="goodsName">
              <template slot-scope="props">
                {{ props.row.goodsName }}
              </template>
            </el-table-column>
            <el-table-column label="规格" prop="skuValue"> </el-table-column>
            <el-table-column label="数量" prop="num">
              <template slot-scope="props">
                {{ props.row.num }}
              </template>
            </el-table-column>
            <el-table-column label="单位" prop="unit"> </el-table-column>
            <el-table-column label="出库量">
              <template slot-scope="props">
                {{ props.row.goodsDosage }}
              </template>
            </el-table-column>
            <el-table-column label="单价" prop="price"> </el-table-column>
            <el-table-column label="换算单位">
              <template slot-scope="props">
                {{ props.row.unit_changesrc }}={{ props.row.unit_changedesc }}
              </template>
            </el-table-column>
            <el-table-column label="小计">
              <template slot-scope="props">
                <!-- {{$public.getSubtotal(props.row)}} -->
                {{ props.row.totalMoney }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="settlement">
      <div class="settlementL"></div>
      <div class="settlementR">
        <span>
          <span>应付金额：</span>
          <span style="margin-right: 30px">￥{{ calcTotalMoney }}</span>
        </span>
      </div>
    </div>
    <!-- 添加套餐 -->
    <div v-if="dialogAddShop_state">
      <dialogAddShop
        :addShopState="dialogAddShop_state"
        :classType="apply_type ? apply_type.value : '0'"
        :shopId="curShopId"
        :tree="[
          {
            id: '604323824335a2f958dc740a',
            children: [{ id: '604323824335a2f958dc740f' }],
          },
        ]"
        @closeOn="dialogAddShop_state = false"
        @submit="submit_dialogAddShop"
      ></dialogAddShop>
    </div>
  </div>
</template>
<script>
import dialogAddShop from "../../../../components/dialog_addShop.vue";

export default {
  components: { dialogAddShop },
  data() {
    return {
      // couponList: [], //用户可用优惠券列表
      couponId: "", //用户选择的优惠券
      // 可用套餐列表
      couPackageList: [],
      couPackageId: "",
      apply_type: "",
      form: {
        payType: 1, // 1全额支付；2计划支付 3套餐卡
        remark: "",
      },
      tableData: [],
      calcTotalMoney: 0,

      // 商品套餐
      dialogAddShop_state: false,
      curPackage: {},

      // 销售人员
      saleManIdList: [],
      staffList: [],
    };
  },
  computed: {
    curShopId() {
      return this.$store.state.shopId;
    },
    couponList() {
      return this.$store.state.yiliaoxin.couponList;
    },
    userInfo() {
      return this.$store.state.yiliaoxin.userInfo;
    },
    curPetInfo() {
      let obj = this.$store.getters["yiliaoxin/curPetInfo"];
      return obj;
    },
    ylfwParams() {
      return this.$store.state.yiliaoxin.ylfwParams;
    },
  },
  watch: {
    curPetInfo(n) {
      console.log(n);
      if (!this.$public.isNull(n._id)) {
        this.apply_type = n.apply_type;
      } else {
        this.apply_type = "";
      }
      this.curPackage = {};
      this.tableData = [];
    },
  },
  mounted() {
    if (!this.$public.isNull(this.curPetInfo._id)) {
      this.apply_type = this.curPetInfo.apply_type;
    } else {
      this.apply_type = "";
    }
    this.getStaffList();
    this.$store.state.yiliaoxin.userController.map((controller) => {
      if (controller.invitationType === 3 && controller.userId.length > 0) {
        this.saleManIdList = [controller.userId + "," + controller.userName];
      }
    });
  },
  methods: {
    // 选择套餐
    changeCouPackage() {
      if (this.couPackageId) {
        console.log(this.couPackageId, "套餐id");
        let obj = {
          groupId: this.couPackageId,
        };
        this.submit_dialogAddShop({ goodsItem: obj, skuItem: {} });
      }
    },
    // 选择优惠券
    changeCoupon() {
      // this.couponList
      if (this.couponId) {
        this.couponList.forEach((item) => {
          if (item._no == this.couponId) {
            // 可用套餐列表
            this.couPackageList = item.apply_range.product_list;
            this.couPackageId = "";
          }
        });
      }else{
        this.couPackageId='';
      }
      console.log(this.couponId);
    },
    // 返回
    back() {
      this.ylfwParams.type = "list";
      this.$store.commit("yiliaoxin/set_ylfwParams", this.ylfwParams);
    },
    submit() {
      if (!this.userInfo._id) {
        this.$message({
          message: "请选择顾客",
          type: "error",
        });
        return false;
      }
      if (!this.curPetInfo._id) {
        this.$message({
          message: "请选择宠物",
          type: "error",
        });
        return false;
      }
      if (this.$public.isNull(this.curPackage.groupId)) {
        this.$message({
          message: "请选择套餐",
          type: "error",
        });
        return false;
      }
      if (this.$public.isNull(this.saleManIdList)) {
        this.$message({
          message: "请销售人员",
          type: "error",
        });
        return false;
      }
      let salesMans = [];
      for (let i = 0; i < this.saleManIdList.length; i++) {
        let arr = this.saleManIdList[i].split(",");
        salesMans.push({ userId: arr[0], userName: arr[1] });
      }
      let params = {
        memberId: this.userInfo._id,
        memberName: this.userInfo.basic_info.nick_name,
        memberMobile: this.userInfo.basic_info.user_mobile,
        petId: this.curPetInfo._id,
        petName: this.curPetInfo.nick_name,
        petType: this.curPetInfo.apply_type.title, // 猫类；犬类
        typeName: this.curPetInfo.category_info.name,
        sex: this.curPetInfo.pet_sex,
        birthDay: this.curPetInfo.bron_date,
        medicalServiceId: this.curPackage.groupId, // 服务套餐
        medicalServiceName: this.curPackage.title,
        payMoney: this.curPackage.total_money,
        payType: this.form.payType, // 1全额支付；2计划支付 3套餐卡
        remark: this.form.remark,
        couponNo: this.couponId,
        // "cardNumber": this.form.cardNumber,  // 优惠卡号
        // "cardBindId": this.$public.getMatchingItem(this.cardsList,'card_number',this.form.cardNumber)._id||'',  // 优惠卡记录id
        // "cardName": this.$public.getMatchingItem(this.cardsList,'card_number',this.form.cardNumber).name||'',     // 优惠卡 名称
        salesMans: salesMans,
        goodsItems: this.tableData,
      };
      let loading = this.$loading();
      this.$http.post("/api/MedicalService/Insert", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.ylfwParams.curRow = { id: res.data };
          console.log(this.ylfwParams.curRow);
          this.$store.commit("yiliaoxin/set_ylfwParams", this.ylfwParams);
          if (this.userInfo._id) {
            this.$store.dispatch("yiliaoxin/get_couponList", this.userInfo._id);
          }
          this.ylfwParams.type = "edit";
        }
      });
    },
    // 套餐
    open_dialogAddShop() {
      this.dialogAddShop_state = true;
    },
    submit_dialogAddShop({ goodsItem, skuItem, wayItem, goodsType }) {
      console.log(goodsItem, "111111111");
      this.dialogAddShop_state = false;
      let params = {
        id: goodsItem.groupId,
      };
      this.$http
        .get(process.env.VUE_APP_Url2 + "api/product/group/service", params)
        .then((res) => {
          if (res.code == 0) {
            console.log(res.data, "套餐10111111111111111");
            this.curPackage = res.data;
            let table = [];
            for (let i = 0; i < this.curPackage.group_items.length; i++) {
              let goods = this.curPackage.group_items[i];
              let one = {};
              if (goods.goods_type === 1) {
                one = {
                  goodsId: goods.goods_id,
                  goodsName: goods.goods_name,
                  goodsType: goods.goods_type,
                  brand: goods.brand_name,
                  categoryId: goods.model.category_info
                    ? goods.model.category_info._id
                    : "",
                  categoryName: goods.model.category_info
                    ? goods.model.category_info.name
                    : "",
                  skuValue: goods.sku_name,
                  skus: goods.sku_id,
                  unit: skuItem.frequency_text || "",
                  unitId: goods.packing_way_id,
                  outUnit: goods.model.old_packinfo_info.unit,
                  originalPrice: goods.src_price,
                  price: goods.custom_price,
                  beforePrice: 0,
                  num: goods.use_num,
                  activityId: "",
                  activityName: "",
                  totalMoney: goods.custom_total_money,
                  goodsUsage: "",
                  goodsDosage: goods.out_num,
                  goodsTimes: "",
                  remark: "",
                  canActivity: false,
                  allowWholesale: goods.model.medical_ext_info.allow_wholesale,
                  dosageCeiling: goods.model.medical_ext_info.dosage_ceiling,
                  dosageCeilingValue:
                    goods.model.medical_ext_info.dosage_ceiling_value,
                  countPriceDosage: 0,
                  joinCommission: this.curPackage.join_commission,
                };
              } else if (goods.goods_type === 4) {
                let skuItem = {};
                // console.log(goods.model.serviceItems);
                if (
                  !this.$public.isNull(goods.model) &&
                  !this.$public.isNull(goods.model.serviceItems)
                ) {
                  for (let a = 0; a < goods.model.serviceItems.length; a++) {
                    if (
                      goods.sku_id ===
                      goods.model.serviceItems[a].service_objectId
                    ) {
                      skuItem = goods.model.serviceItems[a];
                    }
                  }
                }
                one = {
                  goodsId: goods.goods_id,
                  goodsName: goods.goods_name,
                  goodsType: goods.goods_type,
                  brand: goods.brand_name,
                  num: goods.use_num,
                  goodsDosage: goods.out_num,
                  originalPrice: goods.src_price,
                  price: goods.custom_price,
                  totalMoney: goods.custom_total_money,
                  skuValue: goods.sku_name,
                  skus: goods.sku_id,
                  unit: skuItem.frequency_text || "",
                  unitId: goods.packing_way_id,
                  joinCommission: this.curPackage.join_commission,
                  isNeedCode: skuItem.use_consumableMaterial_status, // 是否有耗材
                };
              }
              table.push(one);
            }
            this.tableData = table;
            this.calcTotalMoney = 0;
            if (this.couPackageId) {
              this.calcTotalMoney = 0;
            } else {
              for (let i = 0; i < this.tableData.length; i++) {
                this.calcTotalMoney = this.$public.jia(
                  this.calcTotalMoney,
                  this.tableData[i].totalMoney
                );
              }
            }
          }
        });
    },
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      this.$http.get("/api/Staff/List", params).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data.data;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  padding-bottom: 68px;
  box-sizing: border-box;
  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;
    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;
      .titleL {
        width: 50%;
        font-size: 14px;
        font-weight: bold;
      }
      .titleR {
        width: 50%;
        text-align: right;
        .titleRText {
          display: inline-block;
          font-size: 14px;
          color: $mainColor;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
    .content {
      height: calc(100% - 47px);
      .msg {
        display: flex;
        flex-wrap: nowrap;
        .msgItem {
          width: 25%;
          display: flex;
          padding: 23px 0;
          .label {
            font-size: 14px;
            color: $fontColor;
            text-align: right;
            line-height: 32px;
            margin-right: 4px;
            margin-left: 10px;
          }
          .value {
            font-size: 14px;
            color: $fontColor;
          }
        }
      }
      .review {
        height: calc(100% - 140px);
      }
    }
  }
  .settlement {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    padding: 12px 20px;
    box-sizing: border-box;
    .settlementL {
      width: 40%;
      font-size: 14px;
      line-height: 32px;
    }
    .settlementR {
      width: 60%;
      text-align: right;
      font-size: 14px;
      line-height: 32px;
      .text {
        color: $fontColor;
        font-size: 14px;
        padding: 0px 24px 0;
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
